// Entry para Section Logbook - incluye campos de section
export interface Entry {
	EntryId: number;
	ShiftId: number;
	AssetId: number | null;
	Shift: string | null;
	Crew: string | null;
	Title: string;
	Content: string;
	CreateTimestamp: Date | null;
	UpdateTimestamp: Date | null;
	LogEntryTypeCode: "M" | "A" | "S"; // 'S' = Section entry
	Author: string | null;
	UpdatedBy: string | null;
	AttachmentCount?: number;
	SectionId: number | null;
	SectionName?: string;
	SectionFamilyName?: string;
	WeighUp?: string | null;
	BreakIn?: string | null;
	SectionNotes?: string | null;
}

export const ENTRY_INITIAL_VALUES: Entry = {
	EntryId: 0,
	ShiftId: 0,
	AssetId: null,
	Title: "",
	Content: "",
	CreateTimestamp: new Date(),
	UpdateTimestamp: new Date(),
	LogEntryTypeCode: "S", // Default 'S'
	Shift: null,
	Crew: null,
	Author: null,
	UpdatedBy: null,
	AttachmentCount: 0,
	// Section defaults
	SectionId: null,
	SectionName: undefined,
	SectionFamilyName: undefined,
	WeighUp: undefined,
	BreakIn: undefined,
	SectionNotes: undefined,
};
